import reduce from "lodash/reduce";
import concat from "lodash/concat";

/**
 * Iterates over a collection and invokes the function. The returned promised
 * are chained and their results are accumulated in an array.
 *
 * @param collection The collection to iterate over.
 * @param iteratee The function invoked per iteration. Should return a promise.
 * @returns {*} Accumulated results of all promises
 */
export function chain(collection, iteratee) {
  return reduce(collection, function (accumulatorPromise, value, key) {
    return accumulatorPromise.then(function (results) {
      return iteratee(value, key)
        .then(function (result) {
          // accumulate results
          return concat(results, [result]);
        });
    });
  }, Promise.resolve([]));
}
